import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActivePainSort, setActivePainSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopPain = ({ location, currentQuery, setCurrentQuery, pains, getSortParams, isHome }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-pain button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.pains) {
        let pains = query.pains.split('_');
        pains.map(size => {
            var element = document.getElementById("pain_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.pains) {
            return query.pains + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel est le type de sa douleur principale ?" : "Type de douleur principale :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-pain mt-10" style={{display: 'block'}}>
                        {pains ? (
                            <ul>
                                {pains.map((pain, key) => {
                                    return (
                                        <li key={"pain_"+key}>
                                            <button
                                                className="toto"
                                                id={"pain_"+pain}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("pain", "");
                                                        setCurrentQuery({ ...currentQuery, pains: ""});
                                                        deleteActivePainSort(e);
                                                    } else {
                                                        getSortParams("pain", pain);
                                                        setCurrentQuery({ ...currentQuery, pains: pain, types: "", analysis: ""});
                                                        setActivePainSort(e);
                                                    }
                                                }}
                                            >
                                                {t(pain.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel est le type de sa douleur principale ?" : "Type de douleur principale :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-pain mt-10">
                        {pains ? (
                            <ul>
                                {pains.map((pain, key) => {
                                    return (
                                        <li key={"pain_"+key}>
                                            <button
                                                className="toto"
                                                id={"pain_"+pain}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("pain", "");
                                                        setCurrentQuery({ ...currentQuery, pains: ""});
                                                        deleteActivePainSort(e);
                                                    } else {
                                                        getSortParams("pain", pain);
                                                        setCurrentQuery({ ...currentQuery, pains: pain, types: "", analysis: ""});
                                                        setActivePainSort(e);
                                                    }
                                                }}
                                            >
                                                {t(pain.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function ConstructRemovePainQueryPath(query, sizeToRemove) {
    if (query && query.pains) {
        let pains = query.pains.split('_');
        pains = pains.filter(size => {
            return size !== sizeToRemove;
        })
        if (pains.length > 0) {
            let newSizeQuery = ""
            pains.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopPain.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopPain;
